var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          !_vm.intialized
            ? _c(
                "div",
                {
                  staticClass: "modal-dialog modal-xl modal-dialog-scrollable",
                },
                [
                  _c("div", { staticClass: "modal-content" }, [
                    _c("div", { staticClass: "modal-header" }, [
                      _c("h5", { staticClass: "modal-title" }, [
                        _vm._v("Access links"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: { type: "button" },
                          on: { click: _vm.close },
                        },
                        [_vm._v("×")]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-secondary",
                          attrs: { type: "button" },
                          on: { click: _vm.close },
                        },
                        [_vm._v("Close")]
                      ),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.intialized && _vm.step === "links"
            ? _c(
                "div",
                {
                  staticClass: "modal-dialog modal-xl modal-dialog-scrollable",
                },
                [
                  _c("div", { staticClass: "modal-content" }, [
                    _c("div", { staticClass: "modal-header" }, [
                      _c("h5", { staticClass: "modal-title" }, [
                        _vm._v("Access links"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: { type: "button" },
                          on: { click: _vm.close },
                        },
                        [_vm._v("×")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-body" }, [
                      _c("div", [
                        _c("table", { staticClass: "table table-hover" }, [
                          _vm._m(1),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(_vm.panelists, function (p) {
                              return _c("tr", { key: p.ProjectUserId }, [
                                _c("td", [
                                  _c("span", [_vm._v(_vm._s(p.Name))]),
                                  _c("br"),
                                  _vm._v(" "),
                                  p.HasEmail
                                    ? _c(
                                        "span",
                                        { staticClass: "text-muted" },
                                        [_vm._v(_vm._s(p.Email))]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !p.HasEmail
                                    ? _c(
                                        "span",
                                        { staticClass: "text-danger" },
                                        [_vm._v("Email not provided")]
                                      )
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "align-middle" }, [
                                  _c("div", { staticClass: "input-group" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: p.AccessUrl,
                                          expression: "p.AccessUrl",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: { type: "text", readonly: "" },
                                      domProps: { value: p.AccessUrl },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            p,
                                            "AccessUrl",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "input-group-append" },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-outline-secondary",
                                            attrs: {
                                              type: "button",
                                              title: "Copy to clipboard",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.copyAccessUrlToClipboard(
                                                  p
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-clipboard",
                                              attrs: { "aria-hidden": "true" },
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-outline-secondary",
                                            attrs: {
                                              type: "button",
                                              title: "Send link via email",
                                              disabled: !p.HasEmail,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.emailOne(p)
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa-regular fa-envelope",
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ])
                            }),
                            0
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-secondary",
                          attrs: { type: "button" },
                          on: { click: _vm.handleDownloadLinks },
                        },
                        [_vm._v("Download links")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-secondary",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.emailAll.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v("Email all")]
                      ),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.intialized && _vm.step === "email"
            ? _c(
                "div",
                {
                  staticClass: "modal-dialog modal-xl modal-dialog-scrollable",
                },
                [
                  _c("div", { staticClass: "modal-content" }, [
                    _c("div", { staticClass: "modal-header" }, [
                      _c("h5", { staticClass: "modal-title" }, [
                        _vm._v(
                          "Send email (" + _vm._s(_vm.recipients.length) + ")"
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: { type: "button" },
                          on: { click: _vm.close },
                        },
                        [_vm._v("×")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-body" }, [
                      _c(
                        "form",
                        {
                          attrs: { id: "survey-access-links-email-form" },
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.handleSendEmail.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [_vm._v("Subject:")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.emailSubject,
                                  expression: "emailSubject",
                                  modifiers: { trim: true },
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text", required: "" },
                              domProps: { value: _vm.emailSubject },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.emailSubject = $event.target.value.trim()
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.emailBody,
                                  expression: "emailBody",
                                  modifiers: { trim: true },
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { rows: "5", required: "" },
                              domProps: { value: _vm.emailBody },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.emailBody = $event.target.value.trim()
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "error" }, [
                              _vm._v(_vm._s(_vm.emailBodyError)),
                            ]),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-secondary",
                          attrs: { type: "button" },
                          on: { click: _vm.showLinks },
                        },
                        [_vm._v("Back")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: {
                            type: "submit",
                            form: "survey-access-links-email-form",
                            disabled: !_vm.canSendEmail,
                          },
                        },
                        [_vm._v("Send email")]
                      ),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "modal-body" }, [
      _c("i", { staticClass: "fa fa-spinner fa-spin" }),
      _vm._v(" Loading...\n                "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", { staticClass: "thead-light" }, [
      _c("tr", [
        _c("th", [_vm._v("Panelist")]),
        _vm._v(" "),
        _c("th", [_vm._v("Access link")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }